import IntermediateReport from './IntermediateReport';

export default IntermediateReport;
